import { render, staticRenderFns } from "./TranscribeDateOfTimeBehaviorEditor.vue?vue&type=template&id=88920566&scoped=true&"
import script from "./TranscribeDateOfTimeBehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./TranscribeDateOfTimeBehaviorEditor.vue?vue&type=script&lang=ts&"
import style0 from "./TranscribeDateOfTimeBehaviorEditor.vue?vue&type=style&index=0&id=88920566&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88920566",
  null
  
)

export default component.exports